import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Typography, Container, Grid2 } from '@mui/material';
import {
  OrgProvider,
  useOrgData,
  useOrgLoading,
} from 'app/contexts/OrganizationContext';
import { Box } from '@mui/system';
import Loading from 'app/components/MatxLoading';

const OrgLayoutContent = () => {
  const org = useOrgData();
  const loading = useOrgLoading();

  if (!org) {
    console.error(
      'Organization context is null. Ensure your component is wrapped with OrgProvider.',
    );
    return (
      <Box>
        <Typography color="error">
          Organization context is not available.
        </Typography>
      </Box>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Grid2 container spacing={2}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {org.name}
          </Typography>
          <Outlet />
        </Box>
      </Grid2>
    </Container>
  );
};
const OrgLayout = () => {
  const { orgId } = useParams();
  return (
    <OrgProvider key={orgId} orgId={orgId}>
      <OrgLayoutContent />
    </OrgProvider>
  );
};

export default OrgLayout;
